export default "__VITE_ASSET__Bd31sHmg__"